import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import Navbar from '../Navbar';
import PdfMenu from './PdfMenu';
import logo from '../../images/Limitless-BNG_WordmarkLogo.png';
import './index.scss';

// To display a PDF menu instead of the structured menu below, import it and
// assign it here, e.g.:
//   import MenuPdf from '../../images/Limitless_menu.pdf';
//   const MENU_PDF = MenuPdf;
const MENU_PDF = null;

const HOURS = [
  ['Monday',    '11:30AM - 2AM'],
  ['Tuesday',   '11:30AM - 2AM'],
  ['Wednesday', '11:30AM - 2AM'],
  ['Thursday',  '11:30AM - 2AM'],
  ['Friday',    '11:30AM - 2AM'],
  ['Saturday',  '11:30AM - 2AM'],
  ['Sunday',    '11:30AM - 12AM'],
];

const STARTERS = [
  { name: 'Ultimate Nachos', price: '14.99', desc: 'Hand-cut corn tortilla chips with sour cream, jalapeños, cilantro, green onions, tomatoes and cheese with salsa. Additional $3 for pork, chicken, beef' },
  { name: 'Build Your Own Fries', price: '10.99', desc: 'Fresh veggies topped with sour cream and spicy mayo. TOPPING: Pork Belly $3 | Crispy Chicken $3 / Beef $5 | Jerk Chicken $3 | Jerk Pork $3' },
  { name: 'Sisig', price: '14.99', desc: 'Made from chopped and seasoned pork. Served sizzling on a hot plate with onions, chilies, red bell peppers, Japanese mayo and egg' },
  { name: 'Takoyaki', price: '9.99', desc: 'Ball-shaped, wheat flour-based batter filled with octopus, pickled ginger, and green onion' },
  { name: 'Cheese Corn', price: '9.99', desc: 'Melted cheese on sweet corn' },
  { name: 'Spring Rolls (Lumpia Shanghai)', price: '5.99', desc: 'Deep fried hand-rolled Filipino pork spring rolls with a side of sweet chili sauce OR vegetarian spring roll' },
];

const BBQ_SKEWERS = [
  { name: 'Longganisa Skewer (3)', price: '6.75', desc: 'Filipino Style Sausage Sweet and Savoury made with Ground Pork Garlic and Blend of Spices' },
  { name: 'Pork Skewer (3)', price: '6.99', price2: '(9) 19.99', desc: 'Filipino-style pork skewers with our homemade BBQ sauce' },
  { name: 'Chicken Skewer (3)', price: '6.99', price2: '(9) 19.99', desc: 'Filipino-style chicken skewers with our homemade BBQ sauce' },
  { name: 'Beef Skewer (3)', price: '7.99', desc: 'Filipino Street Food. Thin Sliced Beef Seasoned with Dry Spices To Make A Unique Sweet, Smoky and Savoury Flavour' },
  { name: 'Shrimp Skewer (3)', price: '9.99', desc: 'Highlight The Natural Sweetness of the Shrimp. Enhanced By Savoury, Tangy, and Slightly Sweet Marinate' },
];

const DAILY_SPECIALS = [
  { day: 'MONDAY & WEDNESDAY', title: '$10 Chicken Wings With a Side of Fries', desc: 'SAUCE: Buffalo, Maple Chipotle, Sweet Thai, Smoked BBQ, House Hot Sauce, Spicy Ranch, Honey Garlic, Sweet Fusion, Hot BBQ, Hot Creamy Parmesan\nDRY RUB: Mango Chipotle, Cajun, Salt & Pepper' },
  { day: 'TUESDAY', title: '$2.99 Taco Tuesday', desc: '(Chicken, Beef, Pork, Jerk Chicken/Pork, Shrimp, Fish)' },
  { day: 'THURSDAY', title: 'Half Price Starters', desc: '' },
  { day: 'FRIDAY & SATURDAY', title: '$4 Shots', desc: '(Bottom Shelf Shots Only)' },
  { day: 'SUNDAY', title: '$7 Signature Cocktails', desc: '' },
];

const MAINS = [
  { name: 'Limitless Mania', price: '53.99', desc: 'Limitless Mania comes with a Limitless platter, 1lb of wings, cheesecake, and a side of rice or fries' },
  { name: 'Limitless Platter', price: '40.99', desc: 'Adobo Lemongrass Chicken Thigh, Pork Belly, Pork Chop, and a choice of BBQ Pork/Chicken Skewers (3)' },
  { name: 'Beef Short Rib Plate', price: '18.99', desc: 'Thinly sliced Korean-inspired beef short ribs' },
  { name: 'Stir-fried Garlic Beef Plate', price: '16.49', desc: 'Stir-fried garlic beef cubes' },
  { name: 'Build Your Own Grilled Platter', price: '15.50', desc: 'Choice of 2 proteins: Adobo Lemongrass Chicken, Pork Belly, Pork Chop, or 3 BBQ Skewers (chicken or pork)' },
  { name: 'Crispy Pork Cutlet', price: '14.99', desc: 'Panko-crusted pork cutlet topped with okonomiyaki sauce, Japanese mayo, nori, and green onions' },
];

const SEAFOOD = [
  { name: 'Land & Sea Platter', price: '29.99', desc: 'Grilled milkfish and 6 skewers of chicken or pork skewers' },
  { name: 'Grilled Milkfish Plate', price: '18.99', desc: 'Grilled milkfish tossed in our mixed vegetables and house vinegar topped with Japanese mayo' },
  { name: 'Oven Baked Clams', price: '13.99', desc: 'Tender, juicy clams topped with a blend of spices and then baked to perfection' },
  { name: 'Garlic Butter Shrimp', price: '11.99', desc: 'Sautéed shrimp in a rich garlic butter sauce, finished with fresh herbs' },
];

const CHICKEN_SAUCES = 'SAUCE: Buffalo, Maple Chipotle, Sweet Thai, Smoked BBQ, House Hot Sauce, Spicy Ranch, Honey Garlic, Sweet Fusion, Hot BBQ, Hot Creamy Parmesan';
const CHICKEN_DRY_RUB = 'DRY RUB: Mango Chipotle, Cajun, Salt & Pepper';

const CHICKEN = [
  { name: 'Chicken Wings and Fries', price: '15.99', desc: 'Crispy golden chicken wings' },
  { name: 'Chicken Fingers (4) and Fries', price: '13.99', desc: 'Chicken fingers tossed in your choice of sauce' },
  {
    name: 'Popcorn Chicken', price: '11.99',
    desc: 'Bite-sized pieces of juicy chicken, coated in a crispy and savory batter tossed in your choice of sauce/rub',
    variants: [
      'Umai Style: topped with Japanese mayo, okonomiyaki sauce, green onions, sesame seed, seaweed, and bonito flakes',
      'Kamikaze Style: topped with fries, cheese, chicken, signature sauce, BBQ sauce, and green onion',
    ],
  },
];

const BURGERS = [
  { name: 'Limitless Mega Burger', price: '14.99', desc: 'Grilled beef patty with lettuce, tomatoes, cheese, pickles, and our secret burger sauce' },
  { name: 'Pulled Pork Sandwich', price: '14.99', desc: 'Smoked pork shoulder with house spice blend and smothered in Kansas BBQ Sauce' },
  { name: 'Beef Sandwich', price: '14.99', desc: 'Thin Sliced Ribeye with sautéed onion topped with American cheese on a brioche bun' },
  { name: 'Crispy Chicken Burger', price: '14.99', desc: 'Deep-fried chicken thigh fillet on a brioche bun' },
];

const TACOS = [
  { name: 'Street Tacos (3)', price: '13.99', desc: 'Loaded with crisp coleslaw, juicy tomatoes, fresh green onions, and drizzled with spicy mayo.', protein: 'Choice of Protein: Chicken, Pork, or Beef' },
  { name: 'Mexican Style Tacos (3)', price: '13.99', desc: 'Loaded with crisp coleslaw, mixed with onion, cilantro and salsa verde.', protein: 'Choice of Protein: Beef or Pork' },
  { name: 'Caribbean Heat Tacos (3)', price: '13.99', desc: 'Topped with coleslaw, tomato, green onion, spicy mayo and jerk sauce.', protein: 'Choice of Protein: Chicken or Jerk Pork' },
  { name: 'Seafood Tacos (3)', price: '15.99', desc: 'Loaded with crisp coleslaw, juicy tomatoes, fresh green onions, and drizzled with spicy mayo.', protein: 'Choice of Protein: Shrimp or Fish' },
];

const SIDES = [
  { name: 'White Rice', price: '1.99' },
  { name: 'Garlic Rice', price: '2.99' },
  { name: 'French Fries', price: '5.99' },
  { name: 'Onion Rings', price: '6.99' },
];

const SWEETS = [
  { name: 'Ooey Gooey Chocolate Chip Cookie', price: '2.99', desc: 'Chewy on the outside, chewy on the inside. Made with brown butter, semi-sweet chocolate and Belgian dark chocolate.' },
  { name: 'Ube Basque Cheesecake', price: '8.50', desc: '' },
  { name: 'Soda', price: '1.99', desc: 'Coke, Diet Coke, Coke Zero, Sprite, Canada Dry, Fuse' },
];

const MenuItem = ({ name, price, price2, desc, protein, variants }) => (
  <div className="menu-item">
    <div className="menu-item-header">
      <span className="item-name">{name}</span>
      <span className="item-price">{price}{price2 && <span className="item-price2"> / {price2}</span>}</span>
    </div>
    {desc && <p className="item-desc">{desc}</p>}
    {protein && <p className="item-protein">{protein}</p>}
    {variants && variants.map((v, i) => <p className="item-variant" key={i}>{v}</p>)}
  </div>
);

class NewMenu extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="new-menu">
        <Navbar />

        <div className="menu-body">
          <Link to="/landing2" className="back-btn">&#8592;</Link>

          {MENU_PDF ? <PdfMenu file={MENU_PDF} /> : <>

          <h1 className="menu-heading">LIMITLESS BAR &amp; GRILL</h1>

          {/* Starters */}
          <section className="menu-section">
            <h2 className="section-header">STARTERS</h2>
            {STARTERS.map(item => <MenuItem key={item.name} {...item} />)}
          </section>

          {/* BBQ Skewers */}
          <section className="menu-section">
            <h2 className="section-header">BBQ SKEWERS</h2>
            {BBQ_SKEWERS.map(item => <MenuItem key={item.name} {...item} />)}
          </section>

          {/* Daily Specials */}
          <section className="daily-specials-box">
            <h2 className="specials-title">DAILY SPECIALS</h2>
            {DAILY_SPECIALS.map(({ day, title, desc }) => (
              <div className="special-item" key={day}>
                <p className="special-day">{day}</p>
                <p className="special-title">{title}</p>
                {desc && <p className="special-desc">{desc}</p>}
              </div>
            ))}
          </section>

          {/* Mains */}
          <section className="menu-section">
            <h2 className="section-header">MAINS</h2>
            <p className="section-note">ALL PLATTER COMES WITH A SIDE OF RICE — UPGRADE TO FRIED OR GARLIC RICE $2</p>
            {MAINS.map(item => <MenuItem key={item.name} {...item} />)}
          </section>

          <p className="allergy-note">PLEASE INFORM YOUR SERVER OF ANY ALLERGIES</p>

          {/* Seafood + Burgers row */}
          <div className="two-col">
            <section className="menu-section">
              <h2 className="section-header">SEAFOOD</h2>
              {SEAFOOD.map(item => <MenuItem key={item.name} {...item} />)}
            </section>

            <section className="menu-section">
              <h2 className="section-header">BURGERS</h2>
              <p className="section-note">ALL BURGER COMES WITH A SIDE OF FRIES — UPGRADE TO ONION RINGS $2</p>
              {BURGERS.map(item => <MenuItem key={item.name} {...item} />)}
            </section>
          </div>

          {/* Chicken */}
          <section className="menu-section">
            <h2 className="section-header">CHICKEN</h2>
            <p className="section-note">{CHICKEN_SAUCES}</p>
            <p className="section-note">{CHICKEN_DRY_RUB}</p>
            {CHICKEN.map(item => <MenuItem key={item.name} {...item} />)}
          </section>

          {/* Tacos */}
          <section className="menu-section">
            <h2 className="section-header">TACOS</h2>
            {TACOS.map(item => <MenuItem key={item.name} {...item} />)}
          </section>

          {/* Sides + Sweets row */}
          <div className="two-col">
            <section className="menu-section">
              <h2 className="section-header">SIDES</h2>
              {SIDES.map(item => <MenuItem key={item.name} {...item} />)}
            </section>

            <section className="menu-section">
              <h2 className="section-header">SWEETS</h2>
              {SWEETS.map(item => <MenuItem key={item.name} {...item} />)}
            </section>
          </div>

          <p className="allergy-note">PLEASE INFORM YOUR SERVER OF ANY ALLERGIES</p>

          </>}
        </div>

        {/* Footer */}
        <footer className="footer" id="contact">
          <div className="footer-top">
            <div className="footer-col">
              <h3>Contact Us</h3>
              <p>1450 Centre St., Unit 3</p>
              <p>L4J 3N1, Thornhill, ON</p>
              <br />
              <p>T: (905) 597-5252</p>
              <p>E: limitlessbarandgrill@gmail.com</p>
            </div>
            <div className="footer-col">
              <h3>Store Hours</h3>
              {HOURS.map(([day, hrs]) => (
                <div className="hours-row" key={day}>
                  <span>{day}</span>
                  <span>{hrs}</span>
                </div>
              ))}
            </div>
            <div className="footer-col footer-logo-col">
              <img src={logo} alt="Limitless Bar & Grill" className="footer-logo" />
            </div>
          </div>
          <div className="footer-social">
            <a href="https://www.facebook.com/limitlessbng" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
            </a>
            <a href="https://www.instagram.com/limitlessbng" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
          </div>
        </footer>
      </div>
    );
  }
}

export default NewMenu;
